import {
  getFeedback,
  respondToFeedback,
  FeedbackRecord,
} from "../services/admin-feedback-service";

export function renderFeedbackPage(): string {
  return `
    <div class="admin-page">
      <div class="admin-container">
        <h1>Feedback</h1>
        <div class="admin-toolbar">
          <select id="feedback-filter" class="admin-select">
            <option value="all">All</option>
            <option value="open" selected>Open</option>
            <option value="responded">Responded</option>
            <option value="closed">Closed</option>
          </select>
          <button class="admin-btn admin-btn-outline" id="feedback-refresh-btn">Refresh</button>
        </div>
        <div id="feedback-list-container">
          <p class="admin-loading">Loading feedback...</p>
        </div>
      </div>
    </div>
  `;
}

export function mountFeedbackPage(): void {
  loadFeedback();

  document.getElementById("feedback-filter")!.addEventListener("change", loadFeedback);
  document.getElementById("feedback-refresh-btn")!.addEventListener("click", loadFeedback);
}

async function loadFeedback(): Promise<void> {
  const filter = (document.getElementById("feedback-filter") as HTMLSelectElement).value;
  const container = document.getElementById("feedback-list-container")!;
  container.innerHTML = '<p class="admin-loading">Loading feedback...</p>';

  try {
    const feedback = await getFeedback(filter);
    renderFeedbackList(feedback);
  } catch (err: any) {
    container.innerHTML = `<p class="admin-error">Failed to load feedback: ${err.message}</p>`;
  }
}

function renderFeedbackList(feedback: FeedbackRecord[]): void {
  const container = document.getElementById("feedback-list-container")!;

  if (feedback.length === 0) {
    container.innerHTML = '<p class="admin-empty">No feedback found.</p>';
    return;
  }

  container.innerHTML = feedback
    .map(
      (f) => `
    <div class="feedback-card" data-id="${f.id}">
      <div class="feedback-header">
        <div class="feedback-meta">
          <strong>${escapeHtml(f.subject)}</strong>
          <span class="feedback-email">${escapeHtml(f.userEmail)}</span>
          <span class="feedback-date">${f.createdAt?.toDate?.()?.toLocaleDateString() || "N/A"}</span>
        </div>
        <span class="status-badge status-${f.status}">${f.status}</span>
      </div>
      <div class="feedback-body">
        <p>${escapeHtml(f.message)}</p>
        ${
          f.context
            ? `
          <div class="feedback-context">
            ${f.context.lastQuery ? `<div><strong>Last Query:</strong> ${escapeHtml(f.context.lastQuery)}</div>` : ""}
            ${f.context.documentSnippet ? `<div><strong>Doc Snippet:</strong> ${escapeHtml(f.context.documentSnippet)}</div>` : ""}
          </div>
        `
            : ""
        }
        ${
          f.response
            ? `
          <div class="feedback-response-display">
            <strong>Response:</strong>
            <p>${escapeHtml(f.response)}</p>
            <small>Responded ${f.respondedAt?.toDate?.()?.toLocaleDateString() || ""}</small>
          </div>
        `
            : `
          <div class="feedback-respond-section">
            <textarea class="feedback-respond-input" placeholder="Type your response..." rows="3"></textarea>
            <button class="admin-btn admin-btn-primary admin-btn-sm feedback-respond-btn" data-id="${f.id}">Send Response</button>
          </div>
        `
        }
      </div>
    </div>
  `
    )
    .join("");

  // Response handlers
  container.querySelectorAll(".feedback-respond-btn").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const feedbackId = (btn as HTMLElement).dataset.id!;
      const card = btn.closest(".feedback-card") as HTMLElement;
      const textarea = card.querySelector(".feedback-respond-input") as HTMLTextAreaElement;
      const response = textarea.value.trim();

      if (!response) return;

      const button = btn as HTMLButtonElement;
      button.disabled = true;
      button.textContent = "Sending...";

      try {
        await respondToFeedback(feedbackId, response);
        button.textContent = "Sent!";
        setTimeout(() => loadFeedback(), 1000);
      } catch (err: any) {
        button.textContent = "Failed";
        alert("Failed: " + err.message);
        setTimeout(() => {
          button.textContent = "Send Response";
          button.disabled = false;
        }, 2000);
      }
    });
  });
}

function escapeHtml(text: string): string {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
